import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { Navbar, TopDetailBar } from "../../components";

import "./MainLayout.scss";

function MainLayout() {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  return (
    <div className={`main-layout ${navOpen ? "nav-open" : null}`}>
      <div className="left-bx">
        <Navbar expanded={navOpen} onExpand={() => setNavOpen((prev) => !prev)} activePage={location.pathname} />
      </div>
      <div className="page-content">
        <div className="container">
          <TopDetailBar onNavExpand={() => setNavOpen((prev) => !prev)} />

          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default MainLayout;
